<template>
  <b-tooltip :target="targetId" triggers="hover">
    <b>{{ item.title }}</b><br/>
    <template v-if="item.runes">
      <b>Runes: </b>{{ item.runes }}<br/>
    </template>
    <ul class="text-left">
      <li v-for="(text, index) in item.detail" :key="index">
        {{ text }}
      </li>
    </ul>
  </b-tooltip>
</template>

<script>
export default {
  name: 'EquipmentTooltip',

  props: {
    item: {
      type: Object
    },
    targetId: {
      type: String
    },
  },
}
</script>
